import React, { useMemo } from "react";
import { useStatusMetadata } from "libs/context/StatusMetadataContext";

/**
 * Table status pill — API colors when metadata is loaded, CSS class fallback otherwise.
 */
const StatusMetadataBadge = ({
  accessor,
  pageName = "",
  value,
  className = "px-2 py-1 fw-semibold common-table-status-badge",
  fallbackClassName = "",
  emptyPlaceholder = "—",
}) => {
  const { resolveBadgePresentation, metadataVersion } = useStatusMetadata();

  const presentation = useMemo(
    () =>
      resolveBadgePresentation({
        accessor,
        pageName,
        value,
        fallbackClassName,
      }),
    // metadataVersion: one re-render after API load; resolveBadgePresentation is stable
    [resolveBadgePresentation, accessor, pageName, value, fallbackClassName, metadataVersion]
  );

  if (value === null || value === undefined || String(value).trim() === "") {
    return <span className="text-muted">{emptyPlaceholder}</span>;
  }

  const displayLabel = presentation.displayLabel ?? String(value).trim();

  if (presentation.inlineStyle) {
    return (
      <span className={className} style={presentation.inlineStyle}>
        {displayLabel}
      </span>
    );
  }

  const resolvedClassName = [className, presentation.fallbackClassName || fallbackClassName]
    .filter(Boolean)
    .join(" ");

  return <span className={resolvedClassName || className}>{displayLabel}</span>;
};

export default React.memo(StatusMetadataBadge);
